module.exports = __webpack_public_path__ + "static/Verne5-9693ce425876c60d952baddbed148a00.webp";